import React from 'react';
import type { VehicleDetailsEntity } from '@packages/domain/techline';

import { useTranslation } from 'react-i18next';
import { Typography } from '@packages/ui/shared';
import { getDisplayValue } from '@web/utils';

const vehicleDetailFields = (vehicle: VehicleDetailsEntity) => [
    {
        label: 'techline:vehicleInfo.confirmVehicleDetails.modelYear',
        value: vehicle?.modelYear,
    },
    {
        label: 'techline:vehicleInfo.confirmVehicleDetails.carline',
        value: vehicle?.model,
    },
    {
        label: 'techline:vehicleInfo.confirmVehicleDetails.engineNumber',
        value: vehicle?.engineId,
    },
    {
        label: 'techline:vehicleInfo.confirmVehicleDetails.transmissionNumber',
        value: vehicle?.vehicleTransmissionNumber,
    },
    {
        label: 'techline:vehicleInfo.confirmVehicleDetails.color',
        value: vehicle?.colorCategory,
    },
    {
        label: 'techline:vehicleInfo.confirmVehicleDetails.model',
        value: vehicle?.modelNumber,
    },
    {
        label: 'techline:vehicleInfo.confirmVehicleDetails.modelOption',
        value: vehicle?.optionCode,
    },
];

export function VehicleDetails({ vehicle }: { vehicle: VehicleDetailsEntity }) {
    const { t } = useTranslation();
    const vehicleDetails = vehicleDetailFields(vehicle);
    return (
        <>
            {vehicleDetails.map(({ label, value }, index) => (
                <div
                    key={`${label}-${index}`}
                    data-testid={`vehicle-detail-${index}`}
                    className="col-sm-6 col-md-4 col-lg-3 pt-3 pb-3"
                >
                    <div className="d-flex flex-column">
                        <Typography variant="label">{t(label)}</Typography>
                    </div>
                    <div>
                        <Typography>{getDisplayValue(value)}</Typography>
                    </div>
                </div>
            ))}
        </>
    );
}
